/**
 * @module app.cm
 */

import { autoinject } from 'aurelia-framework';
import { AppLogger } from 'app/shared/lib/logging/app-logger';
import { INotesConfig } from 'app/core/models/essette-interfaces';

@autoinject()
export class ManageCaseNotesPage {

    ////****************** Fields and Properties ************************************////
    protected displayTabs: Record<string, boolean> = {};

    protected notesConfig: INotesConfig = {
        serviceRootUrl: 'CM/Cases',
        targetType: 'CM.CaseNoteCategory',
        moduleCode: 'CM'
    };

    protected captionPrefix: string | null = "Case"
    ////****************** Lifecycle events (in order of execution) *****************////
    constructor(
        private readonly logger: AppLogger) {
        this.logger.source = this;
    }

    ////****************** Element References ***************************************////

    ////****************** Functions ************************************************////
    protected displayTabContents(tabId: string): void {
        this.displayTabs[tabId] = true;
    }

}
